import httpClient from '../../shared/services/httpClient';

export const PlaceDetail = async (placeId: number) => {
  const response = await httpClient.get(`/place/details/id/${placeId}`, { skipAuth: true });
  return response.data;
};

export const PlaceDetailFull = async (placeId: number) => {
  const response = await httpClient.get(`/place/details/full/${placeId}`);
  return response.data;
};

export const PlaceSearch = async (data: FilterParamsDto | null) => {
  const response = await httpClient.post('/place/filter', data, { skipAuth: true });
  return response.data;
};

export const PlaceFind = async () => {
  const response = await httpClient.get('/place/find/all');
  return response.data;
};
